import React from "react";

const WhyBecomeSeller = () => {
  return (
    <section className='why-seller py-80'>
      <div className='container'>
        <div className='section-heading text-center mx-auto'>
          <h5 className=''>Why become a seller on Marketpro?</h5>
          <span className='text-gray-600'>
            More than half the units sold in our stores from independent
            sellers.
          </span>
        </div>
        <div className='row gy-4 justify-content-center'>
          <div className='col-lg-4 col-sm-6'>
            <div className='why-seller-item text-center'>
              <span className='text-main-two-600 text-72 d-inline-flex'>
                <i className='ph ph-gift' />
              </span>
              <h6 className='my-28'>Free Shipping</h6>
              <p className='text-gray-600 max-w-392 mx-auto'>
                Explore insightful content that keeps you ahead of the curve and
                connected to the pulse of what'shappening.
              </p>
            </div>
          </div>
          <div className='col-lg-4 col-sm-6'>
            <div className='why-seller-item text-center'>
              <span className='text-main-two-600 text-72 d-inline-flex'>
                <i className='ph ph-credit-card' />
              </span>
              <h6 className='my-28'>Flexible Payment</h6>
              <p className='text-gray-600 max-w-392 mx-auto'>
                Explore insightful content that keeps you ahead of the curve and
                connected to the pulse of what'shappening.
              </p>
            </div>
          </div>
          <div className='col-lg-4 col-sm-6'>
            <div className='why-seller-item text-center'>
              <span className='text-main-two-600 text-72 d-inline-flex'>
                <i className='ph ph-chats' />
              </span>
              <h6 className='my-28'>Online Support</h6>
              <p className='text-gray-600 max-w-392 mx-auto'>
                Explore insightful content that keeps you ahead of the curve and
                connected to the pulse of what'shappening.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyBecomeSeller;
